module.exports = __webpack_public_path__ + "img/load_curve.46183ee1.png";